
<div class="container">
 
  <h2 class="content-heading"> 
      <button class="btn btn-sm btn-outline-secondary float-right" (click)="clearCache()">Clear Cache</button>
      Cache Status
    </h2>
    
  <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

    <div class="header gridRow row">
        <div class="">Items currently cached</div> 
    </div>

    <div id="scrollableTable">
  
      <div *ngFor="let obj of entities" class="dateRow gridRow row"> 
        <div class="">{{obj}}</div>  
      </div>

    </div>

  </div>
 
  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar> 

 </div>
